import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

import { useMutation, useQueryClient } from '@tanstack/react-query'

const handleDelete = async ({
  pageIds,
  companyId,
}: {
  pageIds: string
  companyId: string
}) => {
  try {
    const response = await axios.delete(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-refresh/pages/${pageIds}`
    )

    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useDeleteRefreshOpportunity = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      pageIds,
      companyId,
    }: {
      pageIds: string
      companyId: string
    }) => handleDelete({ pageIds, companyId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-gap-domain-refresh-params-paginated'],
      })
    },
  })
}
